import React, { useState, useEffect } from 'react';

import 'react-toastify/dist/ReactToastify.css';

import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { get, orderBy } from 'lodash';
import { AutoComplete } from 'primereact/autocomplete';
import Card from '../../../components/card';

import Loading from '../../loading';
import { Input200px } from '../../../styles/inputGroup';
import axiosCoto from '../../../services/axiosCoto';
import IconButton from '../../../components/IconButton';

export default function CadastroUsuarioVendedorLiberado() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const [comprador, setComprador] = useState();
  const [listaCompradores, setListaCompradores] = useState();
  const [filteredCompradores, setFilteredCompradores] = useState(null);

  const [vendedor, setVendedor] = useState();
  const [listaVendedores, setListaVendedores] = useState();
  const [filteredVendedores, setFilteredVendedores] = useState(null);

  const id = get(useParams(), 'id', 0);

  async function salvarRegistro() {
    try {
      setIsLoading(true);

      const shippingData = {
        idComprador: comprador.value,
        emailComprador: comprador.label,
        idVendedor: vendedor.value,
        emailVendedor: vendedor.label,
      };

      if (id > 0) {
        await axiosCoto.put(`/usuariovendedorliberado/${id}`, shippingData);
        toast.success('Usuário vendedor liberado atualizado com sucesso.');
      } else {
        await axiosCoto.post('/usuariovendedorliberado', shippingData);
        toast.success('Usuário vendedor liberado cadastrada com sucesso.');
      }

      setIsLoading(false);

      navigate('/consultausuariovendedorliberado');
    } catch (err) {
      toast.error(err.response.data);
    } finally {
      setIsLoading(false);
    }
  }

  const handleCancel = () => {
    navigate('/consultausuariovendedorliberado');
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let formErros = false;

    if (comprador == null) {
      formErros = true;
      toast.error('Comprador deve ser informado.');
    }

    if (vendedor == null) {
      formErros = true;
      toast.error('Vendedor deve ser informado.');
    }

    if (formErros) return;

    salvarRegistro();
  };

  useEffect(() => {
    async function getUsuarios() {
      try {
        setIsLoading(true);

        const listDropdownCompradores = [];
        const listDropdownVendedores = [];

        const { data: _usuarios } = await axiosCoto.get('/usuario/todos');

        const _usuariosOrdenados = orderBy(_usuarios, 'email', 'asc');

        _usuariosOrdenados.forEach(element => {
          if (element.tipoUsuario === 'COMPRADOR') {
            listDropdownCompradores.push({ label: element.email, value: element.id });
          } else {
            listDropdownVendedores.push({ label: element.email, value: element.id });
          }
        });

        setListaCompradores(listDropdownCompradores);
        setListaVendedores(listDropdownVendedores);
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        toast.error('Não foi possível recuperar os dados do servidor.');
        navigate('/consultausuariovendedorliberado');
      }
    }
    getUsuarios();
  }, [navigate]);

  const searchCompradores = (event) => {
    const listDropdown = [];

    listaCompradores.forEach(element => {
      if (element.label.toLowerCase().startsWith(event.query.toLowerCase())) {
        listDropdown.push({ label: element.label, value: element.value });
      }
    });

    setFilteredCompradores(listDropdown);
  };

  const searchVendedores = (event) => {
    const listDropdown = [];

    listaVendedores.forEach(element => {
      if (element.label.toLowerCase().startsWith(event.query.toLowerCase())) {
        listDropdown.push({ label: element.label, value: element.value });
      }
    });

    setFilteredVendedores(listDropdown);
  };

  return (
    <>
      <Loading isLoading={isLoading} />
      <Card title="Usuário Vendedor Liberação">
        <div className="row form-elo">
          <div className="col-6">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Comprador *
              </Input200px>
              <AutoComplete
                value={comprador}
                maxLength={40}
                suggestions={filteredCompradores}
                completeMethod={searchCompradores}
                field="label"
                dropdown
                forceSelection
                onChange={(e) => setComprador(e.target.value)}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Vendedor *
              </Input200px>
              <AutoComplete
                value={vendedor}
                maxLength={40}
                suggestions={filteredVendedores}
                completeMethod={searchVendedores}
                field="label"
                dropdown
                forceSelection
                onChange={(e) => setVendedor(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="col-12" style={{ textAlign: 'right' }}>
          <IconButton titulo="Salvar" mensagem="Salvar" btnStyle="success" onClick={handleSubmit} icon="check" />
          <IconButton titulo="Cancelar" mensagem="Cancelar" btnStyle="danger" onClick={handleCancel} icon="times" />
        </div>
      </Card>
    </>
  );
}
